import Vue from 'vue';
import Vuex from 'vuex';
import MainModule from './modules/main'
import TourModule from './modules/tour'
import AmplifyModule from './modules/amplify'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    MainModule,
    TourModule,
    AmplifyModule
  }
})